import { createContext } from 'react';

export const TempleConfigContext = createContext(null);
